import PublisherPage from "@components/publisher-page";
import {
  PagePublisherComp,
  ssrPublisher,
  ssrPublishers,
} from "@graphql/generated/page";
import { GetStaticPaths, GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { loadTranslation } from "@lib/utils";

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  const {
    props: { data },
  } = await ssrPublisher.getServerPage(
    {
      variables: {
        id: params?.name?.toString() || "",
      },
    },
    null
  );

  if (!data.publisher) {
    return {
      redirect: {
        destination: "/",
        permanent: true,
      },
    };
  }

  return { props: { data, translation } };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const {
    props: { data },
  } = await ssrPublishers.getServerPage({}, null);

  const paths =
    data.publishers?.map(({ slug }) => ({
      params: { name: slug },
    })) || [];

  return {
    paths,
    fallback: "blocking",
  };
};

const Publisher: PagePublisherComp = ({ data }) => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale;

  const {
    publisher: { name, iconUrl, description },
  } = data;

  return (
    <>
      <NextSeo
        title={"Lumi News | " + name}
        description={description}
        openGraph={{
          url: `https://luminews.my/${locale}${router.asPath}`,
          title: "Lumi News | " + name,
          description: description,
          images: [{ url: iconUrl || "", alt: `${name} image` }],
        }}
      />

      <PublisherPage data={data} />
    </>
  );
};

export default Publisher;
